import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Operator-grade empty state. No greetings, no emoji, no stock art.
 * Single line + a clear primary CTA.
 */
const ApprovalEmptyState = ({ statusFilter }) => {
  const filtered = statusFilter && statusFilter !== 'all';
  const message = filtered
    ? `No ${statusFilter} approval requests in this view.`
    : 'No approval requests yet. Send your first one to get a provider’s signature on an appeal packet.';

  return (
    <Box
      sx={{
        py: 8,
        px: 3,
        textAlign: 'center',
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: '#FFFFFF',
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 480 }}>
          {message}
        </Typography>
        <Button
          variant="contained"
          component={RouterLink}
          to="/approvals/new"
          disableElevation
        >
          New approval
        </Button>
      </Stack>
    </Box>
  );
};

export default ApprovalEmptyState;
